export const PlayfairDisplay = '"Playfair Display", serif'
export const Montserrat = '"Montserrat", sans-serif'
